import Color from 'color';
import React from 'react';
import { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import Icon, { IconType } from '../../icons/Icon';
import { Button, ButtonVariant } from '../Button';
import { Divider } from '../Divider';
import { Dropdown } from '../Dropdown';
import { TextInput } from '../TextInput';

interface ColorPickerProps {
  label: string;
  tooltip?: string;
  color: string;

  onChange: (color: string) => void;
  defaultColor?: string;
}

export default function ColorPicker({ color, label, tooltip, onChange, defaultColor }: ColorPickerProps) {
  const [open, setOpen] = useState(false);

  const [pickerInput, setPickerInput] = useState(color);
  const [textInput, setTextInput] = useState(color);

  const handleChange = (value: string) => {
    try {
      const validHex = new Color(value, 'hex').hex();
      setPickerInput(validHex);
      setTextInput(validHex);
      onChange(validHex);
    } catch {}
  };

  const handleInputChange = (value: string) => {
    if (value[0] !== '#') value = `#${value}`;
    setTextInput(value);
    if (value.length < 7) return;
    handleChange(value);
  };

  return (
    <Dropdown
      maxHeight={null}
      open={open}
      setOpen={setOpen}
      dropdown={
        <div className='grid gap-4 overflow-hidden p-4'>
          <HexColorPicker color={pickerInput} onChange={handleChange} className='!w-full' />
          <div className='flex gap-2'>
            <TextInput onChange={handleInputChange} value={textInput} />
            <div className='h-[40px] w-[60px] rounded-2' style={{ backgroundColor: pickerInput }}></div>
          </div>

          <Divider />
          <div className='flex gap-2'>
            <Button text={t(TranslationKey.save).singular.label} onClick={() => setOpen(false)} />
            {defaultColor && defaultColor !== color && (
              <Button variant={ButtonVariant.secondary} text={'Reset'} onClick={() => handleChange(defaultColor)} />
            )}
          </div>
        </div>
      }
    >
      <button className='w-full text-start' onClick={() => setOpen(open => !open)}>
        <TextInput
          leading={<div className='h-4 w-4 rounded-1' style={{ backgroundColor: color }}></div>}
          trailing={<Icon type={IconType.edit2} size={'h-4 w-4'} stroke={'stroke-gray-900'} />}
          label={label}
          className='min-w-full cursor-pointer'
          value={color}
          tooltip={tooltip}
        />
      </button>
    </Dropdown>
  );
}
